<template>
  <component :is="tag" ref="scrollContainer" class="native-scrollbar">
    <slot />
  </component>
</template>

<script setup lang="ts">
import { ref } from 'vue';

withDefaults(
  defineProps<{
    tag?: string;
  }>(),
  {
    tag: 'div',
  },
);

const scrollContainer = ref<HTMLElement | null>(null);

defineExpose({
  element: scrollContainer,
});
</script>

<style scoped>
.native-scrollbar {
  overflow: auto;
  overscroll-behavior: contain;
}
</style>
